export default __webpack_public_path__ + "static/media/Connecticut5Open.a95ddbd1.jpg";